module.exports = __webpack_public_path__ + "img/bespoke123_11.594adce7.jpg";